// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3qWCf","card":"Cards_card__3nHB-","infected":"Cards_infected__1wQXS","recovered":"Cards_recovered__3OJY9","deaths":"Cards_deaths__nx43M"};